import { CardBlockImage } from "entities/modules/types";
import { doc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, store } from "shared/api/firebase";
import { PageModuleData } from "../types";

type Params = {
  brandId: string;
  moduleId: string;
  pageId: string;
  topPrivacyTipsBlockImage: CardBlockImage;
};

export const savePageTopPrivacyTipsBlockModuleImage = async ({
  moduleId,
  pageId,
  brandId,
  topPrivacyTipsBlockImage,
}: Params) => {
  try {
    const docRef = doc(
      db,
      `brands/${brandId}/pages/${pageId}/modules/${moduleId}`,
    );
    const moduleData = (await getDoc(docRef)).data() as PageModuleData;

    if (!moduleData.topPrivacyTipsBlock || !topPrivacyTipsBlockImage) {
      return null;
    }

    const path = `brands/${brandId}/pages/${pageId}/modules/${moduleId}/top-privacy-tips-block`;

    const imgStorageRef = ref(store, path);

    await uploadBytes(imgStorageRef, topPrivacyTipsBlockImage);

    const updatedBlock = {
      ...moduleData.topPrivacyTipsBlock,
      backgroundImage: path,
    };

    await updateDoc(docRef, {
      topPrivacyTipsBlock: updatedBlock,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving module image:", error);
    throw error; // Or handle it in a way that's appropriate for your app
  }
};
